var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "expand",
    d: "M0,36.625V32.75A.748.748,0,0,1,.75,32H4.625A.376.376,0,0,1,5,32.375v1.25A.376.376,0,0,1,4.625,34H2v2.625A.376.376,0,0,1,1.625,37H.375A.376.376,0,0,1,0,36.625Zm9-4.25v1.25A.376.376,0,0,0,9.375,34H12v2.625a.376.376,0,0,0,.375.375h1.25A.376.376,0,0,0,14,36.625V32.75a.748.748,0,0,0-.75-.75H9.375A.376.376,0,0,0,9,32.375ZM13.625,41h-1.25a.376.376,0,0,0-.375.375V44H9.375A.376.376,0,0,0,9,44.375v1.25A.376.376,0,0,0,9.375,46H13.25a.748.748,0,0,0,.75-.75V41.375A.376.376,0,0,0,13.625,41ZM5,45.625v-1.25A.376.376,0,0,0,4.625,44H2V41.375A.376.376,0,0,0,1.625,41H.375A.376.376,0,0,0,0,41.375V45.25A.748.748,0,0,0,.75,46H4.625A.376.376,0,0,0,5,45.625Z",
    transform: "translate(0 -32)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.d7b0a631df637fb940a99659dc020375.svg";
export { ForwardRef as ReactComponent };